import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';

export const Title = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: bold;
  padding: 20px 0 70px;
  font-size: 3.75rem;
`;

export const ItemArea = styled(Grid)`
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.main};
  cursor: pointer;
  svg {
    font-size: 60px;
    margin-bottom: 15px;
  }
  p {
    font-weight: bold;
  }
  &:hover{
    transition: 0.5s;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;